import {SOPostUser} from '../../core/user/so-post-user';
import {UserCore} from './user.core';
import {SOGetUser} from '../../core/user/so-get-user';
import {FormField, SelectionOption} from 'lionheartland';
import {postUserFormFieldOptions} from './post-user-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {PersonCore} from '../person/person.core';
import {SOGetPerson} from '../../core/person/so-get-person';

export class RAPostUser extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postUserFormFieldOptions);

  RequestClass = SOPostUser

  constructor(
    public entityCore: UserCore
  ) {
    super();
    if (postUserFormFieldOptions.person) {
      postUserFormFieldOptions.person.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('username'),
      this.getFormValueFromIdentifier('password'),
      this.getFormValueFromIdentifier('givenName'),
      this.getFormValueFromIdentifier('surname'),
      this.getFormValueFromIdentifier('email'),
      this.getFormValueFromIdentifier(
        'person',
        SOGetPerson,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}